import { Box, Button, IconButton, Tooltip } from "@mui/material";
import RestartAltOutlinedIcon from "@mui/icons-material/RestartAltOutlined";

const CallsFormSubmit = (props) => {
  const { resetForm, handleSubmit, onSubmit, triggerAll } = props;
  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <Button
          sx={{
            borderRadius: "12px",
            marginTop: "20px",
            padding: "10px 20px",
            backgroundColor: "var(--accent)",
            color: "#fff",
            width: "100%",
            ":hover": {
              backgroundColor: "var(--accent)",
              color: "#fff",
            },
          }}
          onClick={() => {
            triggerAll();
            handleSubmit(onSubmit)();
          }}
        >
          <Box
            sx={{
              color: "#fff",
            }}
          >
            حفظ
          </Box>
        </Button>
        <Tooltip title="اعادة تعيين">
          <IconButton
            sx={{
              backgroundColor: "var(--table-head-bg)",
              borderRadius: "50%",
              padding: "5px !important",
              height: "45px",
              width: "45px",
              marginTop: "20px",
            }}
            onClick={resetForm}
          >
            <RestartAltOutlinedIcon
              sx={{
                color: "var(--accent)",
              }}
            />
          </IconButton>
        </Tooltip>
      </Box>
    </>
  );
};

export default CallsFormSubmit;
